<template>
  <p ref="root" :title="content" class="c-ellipsis">
    <slot/>
  </p>
</template>

<script lang="ts" setup>
  import { onMounted, onUpdated, ref } from 'vue';
  import { elementRef } from '../utils/component';

  const props = defineProps<{
    noTitle?: boolean,
  }>();

  const root = elementRef();
  const content = ref('');

  if (!props.noTitle) {
    onMounted(updateContent);
    onUpdated(updateContent);
  }

  function updateContent() {
    content.value = root.value?.textContent?.trim() ?? '';
  }
</script>

<style lang="scss">
  .c-ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>